<template lang="pug">
.Button(
  :class=`{
    large: size === 'large',
    normal: size === 'normal',
    small: size === 'small',
    ghost: styleName === 'ghost',
    darkghost: styleName === 'darkghost',
    primary: styleName === 'primary',
    common: styleName === 'common'
  }`
  @click="handleClick"
  v-menuHoverSound
  v-menuClickSound
)
  slot
</template>

<script>
export default {
  name: 'km-button',
  components: {},
  props: {
    text: {
      type: String
    },
    size: {
      type: String,
      default: 'normal'
    },
    styleName: {
      type: String,
      default: 'common'
    }
  },
  data() {
    return {
      rankIndex: 0,
      rankName: ''
    }
  },
  computed: {},
  methods: {
    handleClick() {
      this.$emit('click')
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.Button {
  @include button;
  text-align: center;
  border-radius: 100px;

  .icon {
    margin-right: 10px;
  }

  &.normal {
    margin: 0 20px 0 20px;
    padding: 10px 20px;
    transition-property: transform, color, background;

    &:hover {
      background: white;
      color: #000;
      transform: scale(1.1);
    }
  }

  &.large {
    margin: 0 20px;
    padding: 20px;
    border: 3px solid #000;
    font-size: 3rem;
    text-align: center;
    opacity: 1;
    transition-property: transform, color, background;
    border-radius: 10px;
    box-shadow: 0 0 0 5px rgba(#fff, 0.8);

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(1);
    }
  }

  &.ghost {
    border: 1px solid rgba(255, 255, 255, 0.5);
    background: transparent;
    color: #fff;
  }

  &.darkghost {
    border: 1px solid rgba(0, 0, 0, 0.5);
    background: transparent;
    color: #000000;

    &:hover {
      background: yellow;
      color: #000;
    }

    .icon {
      margin-right: 10px;
    }
  }

  &.primary {
    background: orange;
    color: #000;
  }

  &.common {
    background: #eee;
    color: #000;
  }
}
</style>
